import { AfterViewInit, Component, Input, OnChanges } from '@angular/core';
import {
  RevisionStatus,
} from 'src/app/shared/models/autogenerated-coating';
import { RevisionStatusHelper, WorkflowItem } from '../../models/revision-status.model';

@Component({
    selector: 'app-workflow-status-bar',
    templateUrl: './workflow-status-bar.component.html',
    styleUrls: ['./workflow-status-bar.component.scss'],
    standalone: false
})
export class WorkflowStatusBarComponent implements OnChanges, AfterViewInit {


  @Input()
  currentRevisionStatus: RevisionStatus;

  @Input()
  isStatus_0Visible = true;
  @Input()
  isStatus_1Visible = true;
  @Input()
  isStatus_2Visible = true;
  @Input()
  isStatus_3Visible = true;

  navigationItems: WorkflowItem[] = [];

  ngAfterViewInit(): void {
    // Inicializar los navigation items usando el helper centralizado
    this.navigationItems = RevisionStatusHelper.getWorkflowItems({
      isStatus_0Visible: this.isStatus_0Visible,
      isStatus_1Visible: this.isStatus_1Visible,
      isStatus_2Visible: this.isStatus_2Visible,
      isStatus_3Visible: this.isStatus_3Visible
    });
  }

  ngOnChanges() {
    for (let item of this.navigationItems) {
      if (this.currentRevisionStatus === item.status) {
        if(this.currentRevisionStatus === RevisionStatus.PUBLISHED) {
          item.isActive = false;
          item.finished = true;
        } else {
          item.isActive = true;
          break;
        }
      } else {
        item.isActive = false;
        item.finished = true;
      }
    }
  }

  setSingleStatus(
    status: RevisionStatus,
    failed: boolean,
    active?: boolean,
    finished?: boolean
  ) {
    let item = this.navigationItems.find((item) => item.status === status);
    if (item) {
      item.finished = finished ?? item.finished;
      item.isActive = active ?? item.isActive;
      item.isFailed = failed ?? undefined;
    }
  }

  getIcon(workflowItem: WorkflowItem): string {
    if (workflowItem.isActive) {
      return 'radio_button_checked';
    } else if(workflowItem.isFailed) {
      return 'cancel';
    } else if(workflowItem.finished) {
      return 'check_circle';
    } else {
      return 'radio_button_unchecked'
    }
  }
}
